import cn from 'clsx';
import React from 'react';

import { Body1, Body2, Button, Image, UIHeading2, UIHeading4 } from '@cian/ui-kit';

import { formatNumberWithSpaces, transformNumToString, trimToDecimals } from '../../../common/utils';

import { NBSP, PERCENT, RUB } from '../../../common/constants';
import { ETestIds } from '../../constants';
import { IOfferCardProps } from '../OfferCard';
import { LabelComponent } from '../OfferCard/components/LabelComponent';

import * as styles from './styles.css';

export type TOfferCardMobileVariant = 'default' | 'preview';

export interface IOfferCardMobileProps extends IOfferCardProps {
  variant?: TOfferCardMobileVariant;
}

export const OfferCardMobile: React.FC<IOfferCardMobileProps> = ({ offer, onClick, variant = 'default' }) => {
  const isPreview = variant === 'preview';
  const { offerName, iconPath, offerDescription, label, rate, monthlyPayment, type } = offer;

  return (
    <div
      className={cn(styles['card'], isPreview && styles['card--preview'])}
      onClick={isPreview ? onClick : undefined}
      data-testid={`${ETestIds.OfferCard} ${ETestIds.OfferCard}-${type}`}
    >
      <div className={styles['card__heading']}>
        <div className={styles['card__title']}>
          <div className={styles['card__title-text']}>
            {isPreview ? (
              <UIHeading4 color="text-primary-default">{offerName}</UIHeading4>
            ) : (
              <UIHeading2>{offerName}</UIHeading2>
            )}
            {isPreview ? (
              <Body2 display="block" rowEllipsis="2">
                {offerDescription}
              </Body2>
            ) : (
              <Body1 display="block" rowEllipsis="2">
                {offerDescription}
              </Body1>
            )}
          </div>
          <div className={styles['card__title-icon']}>
            <Image src={iconPath} borderRadius={'50%'} title={offerName} alt={offerName} preloader />
          </div>
        </div>
        {!isPreview && <LabelComponent text={label} />}
      </div>
      <div className={styles['card__details']}>
        <div className={styles['card__details-item']}>
          <Body2 color={'text-secondary-default'}>Ставка</Body2>
          <UIHeading4 color={'text-primary-default'}>
            {transformNumToString(trimToDecimals(Number(rate))) + PERCENT}
          </UIHeading4>
        </div>
        <div className={styles['card__details-item']}>
          <Body2 color={'text-secondary-default'}>Платёж</Body2>
          <UIHeading4 color={'text-primary-default'}>
            {'от' + NBSP + formatNumberWithSpaces(monthlyPayment) + NBSP + RUB}
          </UIHeading4>
        </div>
      </div>
      {!isPreview && (
        <Button size="M" theme={'fill_secondary'} onClick={onClick} fullWidth>
          Подробнее
        </Button>
      )}
    </div>
  );
};
